import { action, mutatorAction } from 'satcheljs';
import { getStore } from '../store/presenceStore';
import type InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import type ChatSignInState from '../store/schema/ChatSignInState';

export const addOrUpdatePresence = action(
    'ADD_OR_UPDATE_PRESENCE',
    (sipUri: string, newPresence: InstantMessagePresenceType) => ({
        sipUri,
        newPresence,
    })
);

export const changeSignInState = action(
    'CHANGE_SIGN_IN_STATE',
    (newSignInState: ChatSignInState) => ({ newSignInState })
);

export const setIsRetrySignInAllowed = mutatorAction(
    'SET_IS_RETRY_SIGNIN_ALLOWED',
    (isAllowed: boolean) => {
        getStore().isRetrySignInAllowed = isAllowed;
    }
);

export const setProcessingManualSignIn = mutatorAction(
    'SET_PROCESSING_MANUAL_SIGNIN',
    (isManualSignIn: boolean) => {
        getStore().processingManualSignIn = isManualSignIn;
    }
);
